import { render } from "./AdministracionDoctores.vue?vue&type=template&id=5f5f2e72&scoped=true"
import script from "./AdministracionDoctores.vue?vue&type=script&lang=js"
export * from "./AdministracionDoctores.vue?vue&type=script&lang=js"

import "./AdministracionDoctores.vue?vue&type=style&index=0&id=5f5f2e72&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f5f2e72"]])

export default __exports__